    import React, { useEffect, useState } from "react";
    import { fetchData } from "../api";

    const Posts = () => {
        const [posts, setPosts] = useState([]);

        useEffect(() => {
            fetchData("post", true).then(setPosts);
        }, []);

        return (
            <div>
                <h2>Posts</h2>
                {posts?.map((post) => (
                    <div key={post.id}>
                        <h3>{post.title || "No Title"}</h3>
                        <p>{post.description || "No Description"}</p>
                    </div>
                ))}
            </div>
        );
    };

    export default Posts;
